'use client';

import { useMemo, useRef } from 'react';

//* HOC's
import { withUIContext } from '@/context';

//* Components
import Page from '@/components/common/Page';
import Button from '@/components/common/Button';
import TopBar from '@/components/pages/shop/TopBar';
import Container from '@/components/common/Container';
import ScrollText from '@/components/sections/ScrollText';
import ProductsSection from '@/components/sections/ProductsSection';
import ProductInfoSection from '@/components/pages/product/ProductInfoSection';
import ProductCommentsSection from '@/components/pages/product/ProductCommentsSection';
import ProductReviewFormSection from '@/components/pages/product/ProductReviewFormSection';
import ProductImageGallery from '@/components/pages/product/ProductImageGallery';

//* Style
import ProductStyle from 'styles/pages/ProductStyle';

const Product = ({
	id,
	name,
	breadcrumbs,
	short_description,
	product_information,
	storage_instruction,
	shipping_information,
	price,
	sale_price,
	weight,
	sku,
	image,
	gallery,
	brand,
	tags,
	badges,
	specialOffers,
	average_rating,
	review_count,
	stock_status,
	out_of_stock_message,
	reviews,
	prev_url,
	next_url,
	winWidth,
}) => {
	//! Ref
	const contentProductRef = useRef();

	//! Checks
	const isLargeDesktop = useMemo(() => {
		return winWidth < 2560 ? 3 : 4;
	}, [winWidth]);

	return (
		<Page className='product'>
			<ProductStyle>
				<Container section>
					{winWidth >= 1024 ? (
						<TopBar
							className={'top-bar'}
							breadcrumbs={breadcrumbs}
						/>
					) : null}

					<div
						ref={contentProductRef}
						className={'main-content-container'}
					>
						{prev_url ? (
							<div className={`absolute-button left`}>
								<Button
									className={'rotate'}
									btnType={'arrow'}
									url={prev_url}
								/>
							</div>
						) : null}

						<div className='left-wrapper'>
							<ProductImageGallery
								productId={id}
								image={image}
								gallery={gallery}
								stock_status={stock_status}
								badges={badges}
							/>
						</div>

						<div className='right-wrapper'>
							<ProductInfoSection
								id={id}
								sku={sku}
								name={name}
								tags={tags}
								price={price}
								brand={brand}
								weight={weight}
								sale_price={sale_price}
								review_count={review_count}
								stock_status={stock_status}
								out_of_stock_message={out_of_stock_message}
								average_rating={average_rating}
								short_description={short_description}
								product_information={product_information}
								storage_instruction={storage_instruction}
								shipping_information={shipping_information}
							/>

							<ProductReviewFormSection productId={id} />

							<ProductCommentsSection reviews={reviews} />
						</div>

						{next_url ? (
							<div className={`absolute-button right`}>
								<Button
									btnType={'arrow'}
									url={next_url}
								/>
							</div>
						) : null}
					</div>
				</Container>

				<ScrollText />

				<ProductsSection specialOffers={specialOffers?.slice(0, isLargeDesktop)} />
			</ProductStyle>
		</Page>
	);
};

export default withUIContext(Product, ['winWidth']);
